import "./marketTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress, // Import loading indicator
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const MarketTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Products
  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true); // Set loading state before fetching
      try {
        const res = await axios.get(
          `${BASE_URL}/api/bazar/findAllProduct/${userId}`,
        );
        setData(res.data);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
      setLoading(false); // Set loading state to false after fetching
    };
    fetchProduct();
  }, [userId, BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/bazar/deleteProduct/${id}`,
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error("Error deleting product:", err);
    }
  };

  const handleUpdate = (productData) => {
    navigate("/market/newMarket", { state: { product: productData } }); // Pass user data to Product
  };

  const productListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "productType",
      headerName: "Products",
      width: 230,
      renderCell: (params) => (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={params.row.productImages?.[0]?.url}
            alt="avatar"
          />
          {params.row.productType}
        </div>
      ),
    },
    {
      field: "productName",
      headerName: "Name",
      width: 150,
    },
    {
      field: "productEmail",
      headerName: "Email",
      width: 100,
    },
    {
      field: "productPrice",
      headerName: "Price",
      width: 100,
    },
    {
      field: "productPhone",
      headerName: "Phone",
      width: 100,
    },
    {
      field: "productAddress",
      headerName: "Address",
      width: 200,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <IconButton color="primary" aria-label="addButton">
            <Link to="/market/newMarket">
              <Add />
            </Link>
          </IconButton>

          <IconButton
            onClick={() => handleUpdate(params.row)}
            color="primary"
            aria-label="update"
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => {
              setSelectedProduct(params.row);
              setOpenDialog(true);
            }}
            color="error"
            aria-label="delete"
          >
            <Delete />
          </IconButton>
        </div>
      ),
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedProduct(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedProduct) {
      await handleDelete(selectedProduct._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Products
        </Typography>
        <Link to="/market/newMarket">
          <Button variant="contained" color="primary">
            Add Product
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={productListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Product?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MarketTable;
